export default __webpack_public_path__ + "static/BenTaylor-8be24961d26c8a6e585d1d0081583ac5.jpg";